<template>
  <div>
    <form @keyup.enter="filter()" @submit.prevent>
      <div class="row pt-3">
        <div class="col-md-4">
          <text-input
            v-model="searchForm.name"
            :placeholder="'Pesquisar por cliente'"
          ></text-input>
        </div>
        <div class="col-md-4">
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text">Data</span>
            </div>
            <input
              v-model="searchForm.saved_at_start"
              type="date"
              aria-label="First name"
              class="form-control form-control-sm"
            />
            <input
              v-model="searchForm.saved_at_end"
              type="date"
              aria-label="Last name"
              class="form-control form-control-sm"
            />
          </div>
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn btn-sm btn-secondary mr-3"
            @click="showFilters = !showFilters"
          >
            <i class="fas fa-filter" /> Mais Filtros
          </button>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="filter()"
          >
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>

      <b-collapse v-model="showFilters">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="filter()"
                  :value="'o'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Vendas</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="filter()"
                  :value="'p'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Orçamentos</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="filter()"
                  :value="'d'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Rascunho</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="filter()"
                  :value="'c'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Canceladas</small>
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </form>

    <!-- <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form @keyup.enter="select" @submit.prevent>
            <div class="row">
              <div class="col-md-4">
                <text-input :alias="'Pesquisar por cliente'" v-model="searchForm.name"></text-input>
              </div>
              <div class="col-md-2">
                <date-input v-model="searchForm.saved_at_start" alias="Data Inicial" />
              </div>
              <div class="col-md-2">
                <date-input v-model="searchForm.saved_at_end" alias="Data Final" />
              </div>
              <div class="col-md-2 d-flex align-items-end">
                <div class="form-group">
                  <button type="button" class="btn btn-sm btn-primary" @click="select($event)">
                    <i class="fas fa-search" /> Pesquisar
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div class="row">
            <div class="col-md-12">
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="select($event)" :value="'o'" :unchecked-value="''" v-model="searchForm.status">
                <small>Vendas</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="select($event)" :value="'p'" :unchecked-value="''" v-model="searchForm.status">
                <small>Orçamentos</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="select($event)" :value="'d'" :unchecked-value="''" v-model="searchForm.status">
                <small>Rascunho</small>
              </b-form-checkbox>
              <b-form-checkbox class="d-block d-md-inline" switch inline @change="select($event)" :value="'c'" :unchecked-value="''" v-model="searchForm.status">
                <small>Canceladas</small>
              </b-form-checkbox>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data: () => ({
    showFilters: false,

    searchForm: {
      name: null,
      saved_at_start: null,
      saved_at_end: null,
      status: ["d", "p", "o", ""],
      finance_status: {},
    },
  }),

  watch: {
    searchForm: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      handler() {
        this.$emit("input", this.searchForm);
      },
    },
  },

  methods: {
    filter() {
      this.$emit("filter");
    },
  },
};
</script>

<style>
</style>